import http from 'Services/HttpService';

import { baseUrl } from 'Utils/envLoader';

const NotificationService = {
    getFreshNotifications: (total, page = 1) => {
        const query = `?page=${page > 0 ? page : 1}&total=${total}`;
        return http.get(`${baseUrl}/notifications${query}`);
    },
    countFreshNotifications: () => {
        return http.get(`${baseUrl}/notifications/count`);
    },
    setAsSeen: (NotificationId) => {
        return http.get(`${baseUrl}/notifications/seen/${NotificationId}`);
    },
    getFreshAdminNotification: () => {
        return http.get(`${baseUrl}/notifications/admin/global`);
    },
    getNotificationsByAdmins: () => {
        return http.get(`${baseUrl}/notifications/byAdmins`);
    },
    createNotificationsByAdmin: (body) => {
        return http.post(`${baseUrl}/notifications`, body);
    },
    deleteNotificationByAdmin: (body) => {
        return http.put(`${baseUrl}/notifications`, body);
    },
};

export default NotificationService;
